import { render, staticRenderFns } from "./user-agreement.vue?vue&type=template&id=23fedfab&scoped=true&"
var script = {}
import style0 from "./user-agreement.vue?vue&type=style&index=0&id=23fedfab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fedfab",
  null
  
)

export default component.exports